import {createReducer} from "redux-act";
import * as actions from "modules/actions";
import {ILeague, Privacy} from "modules/types";
import {RequestStateType} from "modules/utils";

export interface ILeagueCreate {
	name: string;
	start_event_id: number;
	end_event_id?: number;
	privacy: Privacy;
	description: string;
	id?: number;
}

export interface ILeagueCreateReducerState {
	created: boolean;
	league: ILeague;
	league_create_state: RequestStateType;
}

const initialState: Partial<ILeagueCreateReducerState> = {
	created: false,
	league_create_state: RequestStateType.Idle,
};

export const create_league = createReducer({}, initialState)
	.on(actions.leagueCreateClear, (_state, payload) => ({
		...initialState,
	}))
	.on(actions.postLeagueCreate, (state) => ({
		...state,
		league_create_state: RequestStateType.Loading,
	}))
	.on(actions.postLeagueCreateSuccess, (state, payload) => ({
		...state,
		created: true,
		league: payload,
		league_create_state: RequestStateType.Success,
	}))
	.on(actions.postLeagueCreateFailed, (state) => ({
		...state,
		league_create_state: RequestStateType.Error,
	}));
